import { render } from "./XYTransactionRecordHistoryTab.vue?vue&type=template&id=6cae73ae&scoped=true"
import script from "./XYTransactionRecordHistoryTab.vue?vue&type=script&lang=ts"
export * from "./XYTransactionRecordHistoryTab.vue?vue&type=script&lang=ts"
script.render = render
script.__scopeId = "data-v-6cae73ae"

export default script